export default "__VITE_ASSET__c9c3c1e0__"